import lodash from 'lodash'
import Base from '../base.store'

const baseUrl = '/api/v1/security/otps'
const base = new Base(baseUrl)

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        generate(context, { data, config }) {
            return base.request.post(`${baseUrl}/generate`, data, { ...config })
        },
    },
    mutations: {
        ...base.mutations
    },
}
